import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {
  AppBar,
  Avatar,
  FlatButton,
  FontIcon,
  IconMenu,
  MenuItem
} from 'material-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/auth';
const logoImage = require('../assets/images/hawkin-logo@2x.png'); // Tell webpack to load image
const defaultAvatar = require('../assets/images/default-avatar.png'); // Tell webpack to load image

export class HeaderNav extends React.Component {
  render() {
    const { currentUser } = this.props;
    let rightElement = <FlatButton
            label="Sign in with Google"
            linkButton={false}
            primary={true}
            onMouseUp={this.props.actions.signInWithGoogle}
            icon={<FontIcon className="material-icons">lock_open</FontIcon>}
          />

    if (currentUser.name !== 'no login') {
      let avatarUrl = defaultAvatar;
      if (currentUser.avatarUrl) {
        avatarUrl = currentUser.avatarUrl.replace(/s[0-9]+\-c/, 's40-c');
      }
      rightElement = <IconMenu
          iconButtonElement={<Avatar src={avatarUrl} size={40}/>}
          anchorOrigin={{horizontal: 'left', vertical: 'top'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onItemTouchTap={this.props.actions.signOut}
        >
          <MenuItem primaryText="SignOut" />
        </IconMenu>

    }

    const icon = <Link to="/"><img src={`${logoImage}`} height="47" /></Link>

    return (
      <header>
        <AppBar title="Hawkin"
          iconElementLeft={icon}
          iconElementRight={rightElement} />
      </header>
    );
  }
}

HeaderNav.propTypes = {
  actions: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderNav);



/** WEBPACK FOOTER **
 ** ./src/components/HeaderNav.js
 **/